<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal-form-reporte-operativo"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar Reporte Operativo</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0 pt-1">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="Filtros">
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Fecha Inicial</label>
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        v-model="filtros.fecha_inicial"
                        :class="
                          $v.filtros.fecha_inicial.$invalid
                            ? 'is-invalid'
                            : 'is-valid'
                        "
                        @input="validaFechas"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label>Fecha Final</label>
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        v-model="filtros.fecha_final"
                        @input="validaFechas"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Transportadora</label>
                    <v-select
                      class="form-control form-control-sm col-md-7 p-0"
                      v-model="filtros.transportadora_id"
                      label="razon_social"
                      :options="listasForms.transportadoras"
                      :filterable="true"
                      :reduce="(e) => e.id"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Bloque</label>
                    <v-select
                      class="form-control form-control-sm col-md-7 p-0"
                      v-model="filtros.bloque_id"
                      label="nombre"
                      :options="listasForms.bloques"
                      :filterable="true"
                      :reduce="(b) => b.id"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Origen</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.origen_id"
                      label="nombre"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.sitiosOrigenes"
                      :filterable="true"
                      :reduce="(o) => o.id"
                    >
                    </v-select>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Destino</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.destino_id"
                      label="nombre"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.sitiosDestinos"
                      :filterable="true"
                      :reduce="(o) => o.id"
                    >
                    </v-select>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Vehículo</label>
                    <v-select
                      class="form-control form-control-sm col-md-7 p-0"
                      v-model="filtros.vehiculo_id"
                      label="placa"
                      :options="listasForms.vehiculos"
                      :filterable="true"
                      :reduce="(v) => v.id"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Remolque</label>
                    <v-select
                      class="form-control form-control-sm col-md-7 p-0"
                      v-model="filtros.remolque_id"
                      label="placa"
                      :options="listasForms.remolques"
                      :filterable="true"
                      :reduce="(r) => r.id"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-5">Conductor</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.conductor_id"
                      label="nombre"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.conductores"
                      :filterable="true"
                      :reduce="(c) => c.id"
                    ></v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              !$v.filtros.$invalid &&
                $store.getters.can(
                  'hidrocarburos.reportes.exportReporteOperativo'
                )
            "
            class="modal-footer justify-content-between"
          >
            <button
              type="button"
              class="btn btn-sm bg-navy"
              @click="generarListadoExcel()"
            >
              Generar Listado
              <i class="fas fa-file-download"> </i>
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";

export default {
  name: "ReporteOperativoExport",

  components: {
    Loading,
    vSelect,
  },

  data() {
    return {
      cargando: false,
      filtros: {
        fecha_inicial: null,
        fecha_final: null,
        transportadora_id: null,
        bloque_id: null,
        origen_id: null,
        destino_id: null,
        vehiculo_id: null,
        remolque_id: null,
        conductor_id: null,
      },
      listasForms: {
        transportadoras: [],
        bloques: [],
        sitiosOrigenes: [],
        sitiosDestinos: [],
        vehiculos: [],
        remolques: [],
        conductores: [],
      },
    };
  },

  validations: {
    filtros: {
      fecha_inicial: {
        required,
      },
    },
  },

  methods: {
    validaFechas() {
      if (this.filtros.fecha_inicial) {
        let hoy = new Date();
        let fecha_inicial = new Date(this.filtros.fecha_inicial);
        fecha_inicial.setDate(fecha_inicial.getDate());

        if (fecha_inicial >= hoy) {
          this.filtros.fecha_inicial = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicial debe ser menor o igual a la fecha actual...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.filtros.fecha_inicial && this.filtros.fecha_final) {
        let fecha_menor = new Date(this.filtros.fecha_inicial);
        let fecha_mayor = new Date(this.filtros.fecha_final);
        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.filtros.fecha_final = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicial no puede ser mayor a la fecha final...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },
    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/reportes/informeOperativo",
        data: { filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          if (!data.error) {
            this.$swal({
              customClass: {
                container: "my-swal",
              },
              icon: "success",
              title: data.message,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            location.href = data.url;
          } else {
            this.$swal({
              icon: "error",
              title: data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
          this.cargando = false;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },
};
</script>
